// extracted by mini-css-extract-plugin
export default {"registerBtn":"Button_registerBtn__t2DDP","loginBtn":"Button_loginBtn__3ACpk","closeButton":"Button_closeButton__CVyAB","cta":"Button_cta__TODV-"};